import logoBenext from "./logo-benext.png";

// Ícones/ilustrações "O que fazemos"
import icMulticanal from "./multicanal.png";
import icAutomacao from "./automacao.png";
import icConversas from "./conversas.png";
import icEvolucao from "./evolucao.png";
import icGuardrail from "./guardrail.png";

// Parceiros / selos
import alexaChampion from "./champion-logo.png";
import googleForStartups from "./google_for_startups.png";
import logoAWS from "./logo-aws.png";
import logoGoogleCloud from "./logo-googlecloud.png";
import logoAlmap from "./logo-almapbbdo.png";
import logoAlexa from "./logo-alexa.png";

// Logos de clientes
import lgAmbev from "./logo-ambev.png";
import lgB3 from "./logo-b3.png";
import lgBayer from "./logo-bayer.png";
import lgBmg from "./logo-bmg.png";
import lgCimed from "./logo-cimed.png";
import lgColgate from "./logo-colgate.png";
import lgFriboi from "./logo-friboi.png";
import lgGoogle from "./logo-google.png";
import lgHeineken from "./logo-heineken.png";
import lgHeinz from "./logo-heinz.png";
import lgHonda from "./logo-honda.png";
import lgJbs from "./logo-jbs.png";
import lgPixbet from "./logo-pixbet.png";
import lgRedbull from "./logo-redbull.png";
import lgSantander from "./logo-santander.png";
import lgSeara from "./logo-seara.png";
import lgTanqueray from "./logo-tanqueray.png";
import lgGloob from "./logo-gloob.png";

export const benext = {
    logo: logoBenext,
};

export const features = [
    { title: "Atuação multicanal", img: icMulticanal },
    { title: "Automação personalizada", img: icAutomacao },
    { title: "Conversas inteligentes", img: icConversas },
    { title: "Evolução constante", img: icEvolucao },
    { title: "Mecanismo GuardRail", img: icGuardrail },
];

export const partners = {
    alexaChampion,
    googleForStartups,
    logoAWS,
    logoGoogleCloud,
    logoAlmap,
    logoAlexa,
};

export const clientLogos = [
    lgAmbev, lgB3, lgBayer, lgBmg, lgCimed, lgColgate, lgFriboi, lgGoogle, lgGloob,
    lgHeineken, lgHeinz, lgHonda, lgJbs, lgPixbet, lgRedbull, lgSantander, lgSeara, lgTanqueray,
];